import { createAction } from "@reduxjs/toolkit";

export const clearProductsState = createAction("products/clearState");

export const editProducts = createAction<{ data: any[] }>(
  "products/editProducts"
);

export const cleanUpLoader = createAction('products/CleanUpLoaders');